<template>
  <LinkButton
    :tag="tag"
    :to="to"
    :class="cssClasses"
    :disabled="disabled"
    :transparent="!disabled"
    :tabindex="disabled ? undefined : tabIndex"
    small-padding
    @click="emitClick"
  >
    <slot />
  </LinkButton>
</template>

<script>
import { LinkButton } from '@i22-td-smarthome/component-library';

export default {
  name: 'DeactivatableLink',
  components: { LinkButton },
  props: {
    to: {
      type: [Object, String, Number],
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    emitOnlyClick: {
      type: Boolean,
      default: false,
    },
    disabledClass: {
      type: String,
      default: 'disabled',
    },
  },
  emits: ['click'],
  computed: {
    tag() {
      if (this.disabled) return 'span';
      if (this.emitOnlyClick) return 'button';
      return 'nuxt-link';
    },
    tabIndex() {
      return this.disabled ? -1 : undefined;
    },
    cssClasses() {
      const classes = ['deactivatable-link'];
      if (this.disabled) {
        classes.push(this.disabledClass);
      }
      return classes;
    },
  },
  methods: {
    emitClick() {
      if (this.disabled) return;
      this.$emit('click', this.to);
    },
  },
};
</script>
